import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface AcceptInviteDate {
  title: string;
  date: string;
}

interface AcceptInviteWishlistItem {
  title: string;
  description?: string;
  link?: string;
}

interface AcceptInviteRequest {
  invite_token: string;
  confirm?: boolean;
  name?: string;
  dates?: AcceptInviteDate[];
  wishlist_items?: AcceptInviteWishlistItem[];
}

interface AcceptInviteSuccessResponse {
  status: 'success';
}

interface AcceptInviteConfirmationResponse {
  status: 'requires_confirmation';
  current_partner_name: string;
  new_partner_name: string;
}

type AcceptInviteResponse =
  | AcceptInviteSuccessResponse
  | AcceptInviteConfirmationResponse;

export function useAcceptInvite() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AcceptInviteRequest) => {
      const response = await api
        .post('invite/accept', { json: data })
        .json<AcceptInviteResponse>();
      return response;
    },
    onSuccess: (data) => {
      if (data.status === 'success') {
        queryClient.invalidateQueries({ queryKey: queryKeys.user.me });
        queryClient.invalidateQueries({
          queryKey: queryKeys.relationship.root,
        });
      }
    },
  });
}
